import { render, staticRenderFns } from "./EmailSettings.vue?vue&type=template&id=1c76193e&scoped=true&"
import script from "./EmailSettings.vue?vue&type=script&lang=js&"
export * from "./EmailSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmailSettings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EmailSettings.vue?vue&type=style&index=1&id=1c76193e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c76193e",
  null
  
)

export default component.exports